// extracted by mini-css-extract-plugin
export default {"warn":"Warn_warn__sN0JZ","icon":"Warn_icon__WL87K","title":"Warn_title__yWAo6","big":"Warn_big__NxTRs","description":"Warn_description__LWQv9"};